//* Vue
import type { ExtractPropTypes } from "vue";
//* 组件库
import type { UiTypes } from "various-ui";

export const DefaultSearchPropsOption = {
    name: { type: String },
    size: { type: String as PropType<UiTypes.size> },
    type: { type: String as PropType<"gene" | "disease" | "model" | "all">, default: "all" },
    mode: { type: String as PropType<"click" | "default" | "select">, default: "default" },
    icon: { type: Boolean, default: true },
    query: { type: Object, default: {} },
    alias: { type: Boolean, default: false },
    width: { type: [Number, String] as PropType<number | string>, default: "100%" },
    height: { type: Number, default: 240 },
    option: { type: Array as PropType<UiTypes.candidate[]> },
    zIndex: { type: Number },
    disabled: { type: Boolean, default: false },
    clearable: { type: Boolean, default: false },
    maxlength: { type: Number },
    widthExtra: { type: Number },
    modelValue: { type: String, required: true, default: "" },
    placeholder: { type: String },
    classExtraName: { type: String },
} as const;

export type DefaultSearchProps = ExtractPropTypes<typeof DefaultSearchPropsOption>;

export const DefaultSearchEmits = {
    "blur": () => true,
    "focus": () => true,
    "input": () => true,
    "search": (_option?: UiTypes.candidate) => true,
    "update:modelValue": (_keyword: string) => true,
};
